export const url_auth_login = 'auth/login'
export const url_auth_logout = 'auth/logout'
export const url_auth_me = 'auth/me'
export const url_auth_password_change = 'auth/password/change'
export const url_auth_password_email = 'auth/password/email'
export const url_auth_password_reset = 'auth/password/reset'
export const url_auth_permissions = 'auth/permissions'
export const url_auth_refresh = 'auth/refresh'
export const url_auth_token_register = 'auth/token/register'
export const url_auth_sso_connections = 'auth/sso/connections'
